import { render } from "./PaginateTable.vue?vue&type=template&id=4abbcc1c"
import script from "./PaginateTable.vue?vue&type=script&lang=js"
export * from "./PaginateTable.vue?vue&type=script&lang=js"

import "./PaginateTable.vue?vue&type=style&index=0&id=4abbcc1c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__